import CentersCascader from '../../../../../elements/Cascader/CentersCascader'
import { rules } from '../../../../../modules/FormItems'
import React, { Component } from 'react'
import { Checkbox, Col, Form, Input, Row, Select } from 'antd'
import Dropdowns from '../../../../../api/Dropdowns'
import { strVal } from '../../../../../modules/Utils'
import Corporate from '../../../../../api/Corporate'
import _, { get } from 'lodash'
import Employees from '../../../../../api/Employees'
import OrganisationsSelect from '../../../../../elements/Select/Organistaions'
import withLoadingSection from '../../../../../elements/HOC/withLoadingSection'
import { compose } from 'recompose'
import TypeSelect from '../../../../../elements/Select/Employee/Type'
import ContractTypeSelect from '../../../../../elements/Select/Employee/ContractType'
import RequisitionsSelect from '../../../../../elements/Select/Employee/Requisitions'

const FormItem = Form.Item
const { TextArea } = Input
const { Option } = Select

class Overview extends Component {
  constructor(props) {
    super(props)
    this.corporateApi = new Corporate()
    this.dropdownApi = new Dropdowns()
    this.api = new Employees()
    this.state = {
      statusList: [],
      contractType: _.get(props, 'contract.contractType'),
      updating: false,
    }
  }

  handleContractTypeChange = (value, option) => {
    this.setState({
      contractType: value,
    })
  }

  render() {
    const formItemLayoutRow = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    }
    const { getFieldDecorator, getFieldValue } = this.props.form
    const { contract } = this.props
    return (
      <Form layout="horizontal">
        <Row>
          <Col span={12}>
            <FormItem label="Title" {...formItemLayoutRow}>
              {getFieldDecorator('title', {
                initialValue: strVal(contract, 'title'),
                rules: [{ required: true, message: "Title can't be empty " }],
              })(<Input placeholder="Title" />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="Employment Type" {...formItemLayoutRow}>
              {getFieldDecorator('employmentType', {
                initialValue: contract.employmentType,
                rules: [
                  {
                    required: true,
                    message: "Employment Type can't be empty ",
                  },
                ],
              })(<TypeSelect />)}
            </FormItem>
          </Col>

          <Col span={12}>
            <FormItem label="Contract Type" {...formItemLayoutRow}>
              {getFieldDecorator('contractType', {
                initialValue: contract.contractType,
                rules: [
                  {
                    required: true,
                    message: "Contract Type can't be empty ",
                  },
                ],
              })(<ContractTypeSelect />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="Blanket" {...formItemLayoutRow}>
              {getFieldDecorator('blanket', {
                initialValue: contract.blanket,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          {this.props.form.getFieldValue('contractType') !== 'casual' && (
            <Col span={12}>
              <FormItem label="Requisition" {...formItemLayoutRow}>
                {getFieldDecorator('requisition._id', {
                  initialValue: _.get(contract, 'requisition._id'),
                  rules: [
                    {
                      required: true,
                      message: "Requisition can't be empty ",
                    },
                  ],
                })(<RequisitionsSelect />)}
              </FormItem>
            </Col>
          )}

          <Col span={12}>
            <FormItem label="Company" {...formItemLayoutRow}>
              {getFieldDecorator('company._id', {
                initialValue: _.get(contract, 'company._id'),
                rules: [{ required: true, message: "Company can't be empty " }],
              })(<OrganisationsSelect />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="Description" {...formItemLayoutRow}>
              {getFieldDecorator('description', {
                initialValue: strVal(contract, 'description'),
              })(<TextArea placeholder="Description" rows={4} />)}
            </FormItem>
          </Col>

          <Col span={12}>
            <Form.Item {...formItemLayoutRow} label="Cost Center">
              {getFieldDecorator('center._id', {
                initialValue: get(contract, 'center._id'),
                rules: rules.select,
              })(
                <CentersCascader
                  key={getFieldValue('company._id')}
                  category={'Cost'}
                  company={getFieldValue('company._id')}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    )
  }
}

export default compose(Form.create(), withLoadingSection)(Overview)
